import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import * as Sentry from '@sentry/react';
import i18n from '../../i18n';
export class RootErrorBoundary extends Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        Sentry.captureException(error, {
            contexts: { react: { componentStack: info.componentStack ?? '' } },
        });
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { className: "flex min-h-screen flex-col items-center justify-center bg-gray-50 p-4 text-center", children: [_jsx("h1", { className: "text-2xl font-bold text-gray-900", children: i18n.t('common:rootError.title') }), _jsx("p", { className: "mt-2 text-gray-600", children: i18n.t('common:rootError.subtitle') }), _jsx("button", { className: "mt-6 rounded-lg bg-primary px-6 py-3 font-medium text-white", onClick: () => window.location.reload(), children: i18n.t('common:rootError.reload') })] }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=RootErrorBoundary.js.map